import { render, staticRenderFns } from "./IrMsbcIntegration.vue?vue&type=template&id=6593db6e&"
import script from "./IrMsbcIntegration.vue?vue&type=script&lang=js&"
export * from "./IrMsbcIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports